<template>
  <div class="Kanit" style="color: black">
    <div class="text-center Kanit" style="font-size: 25px; font-weight: 600">
      งานที่ไม่กดรับ
    </div>
    <div class="pt-9" v-if="jobs && jobs.length">
      <v-card v-for="(job, k) in jobs" :key="k" outlined class="pa-2 mb-3">
        <div style="font-weight: 900; font-size: 11px; margin-bottom: 15px">
          JobID : #{{ job.orderid }} ลูกค้า {{ job.customer_name }}
        </div>
        <div class="px-3">
          <div style="display: flex; flex-direction: row">
            <div>
              <img
                style="height: 60px; width: 80px"
                :src="job.customer_profile_pic"
              />
            </div>
            <div style="align-self: center; margin-left: 20px; font-size: 10px">
              ผู้จ้าง: {{ job.customer_name }}
            </div>
          </div>
          <div style="font-size: 10px; font-weight: bold">
            <div style="font-size: 13px">รายละเอียดงาน</div>
            <div style="line-height: 15px">
              ประเภทงาน: {{ job.work_type }}<br />
              พื้นที่การทาสี: {{ job.work_area }} ตรม.<br />
              สถานที่ปฏิบัติงาน: {{ job.customer_address }}
            </div>
          </div>
          <div>
            <v-btn
              @click="toapainterconfirmorder(job.orderid)"
              class="mt-3"
              small
              color="#14AF43"
              outlined
              block
              :loading="loading == job.orderid"
              rounded
              >รับงานลูกค้า</v-btn
            >
          </div>
        </div>
      </v-card>
    </div>
    <div v-else>
      <Nojob></Nojob>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Nojob from "./Nojob.vue";
export default {
  props: ["value"],
  components: {
    Nojob,
  },
  computed: {
    jobs() {
      return this.value.orderlist.filter((el) => el.status == "ไม่กดรับงาน");
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  data() {
    return {
      loading: "",
    };
  },
  methods: {
    toapainterconfirmorder(orderid) {
      var vm = this;
      var data = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: this.query.pageid,
        orderid,
      };
      this.$swal
        .fire({
          text: "ยืนยันการรับงาน",
          showCancelButton: true,
          confirmButtonText: "ใช่",
          cancelButtonText: "ไม่",
        })
        .then((result) => {
          if (result.value) {
            vm.loading = orderid;
            axios
              .put(
                "https://communitybotbyzwizai.herokuapp.com/toapainterconfirmorder",
                data,
                {
                  headers: { AUTHORIZATION: "Bearer xxx xxx" },
                }
              )
              .then(async (response) => {
                if (response.data && response.data.responsecode == 400) {
                  await this.$swal.fire({
                    icon: "error",
                    text: response.data.reason,
                  });
                  return;
                } else if (response.data.responsecode == 200) {
                  var index = vm.value.orderlist.findIndex(
                    (el) => el.orderid == orderid
                  );
                  vm.$set(vm.value.orderlist, index, {
                    ...vm.value.orderlist[index],
                    status: "กดรับงาน",
                  });
                  vm.value.orderstatus.request_job--;
                  vm.value.orderstatus.contact++;
                }
                vm.loading = "";
              });
          }
        });
    },
  },
};
</script>
